import { render, staticRenderFns } from "./StoreNumber.vue?vue&type=template&id=85defe8c&scoped=true"
import script from "./StoreNumber.vue?vue&type=script&lang=js"
export * from "./StoreNumber.vue?vue&type=script&lang=js"
import style0 from "./StoreNumber.vue?vue&type=style&index=0&id=85defe8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85defe8c",
  null
  
)

export default component.exports